import * as React from 'react';

import { Flex } from '@lightspeed/flame/Core';

import { ScanListing } from '../components/ScanListing';
import { ScanDataContext } from '../context/ScanData';
import { ScanStatus } from '../types';

const ScanQueueList: React.FC = () => {
  const { failedCollection, pendingCollection, doneCollection } = React.useContext(ScanDataContext);

  return (
    <Flex flexDirection="column">
      {failedCollection.length > 0 ? (
        <ScanListing
          title="Failed scans"
          status={ScanStatus.Failed}
          count={failedCollection.length}
          scanCollection={failedCollection}
        />
      ) : null}
      <ScanListing
        title="Pending scans"
        status={ScanStatus.Pending}
        count={pendingCollection.length}
        scanCollection={pendingCollection}
        emptyStateMsg="No items scanned pending"
      />
      <ScanListing
        title="Uploaded scans"
        status={ScanStatus.Done}
        count={doneCollection.length}
        scanCollection={doneCollection}
        emptyStateMsg="No items uploaded"
      />
    </Flex>
  );
};

export default ScanQueueList;
